import merge from 'lodash/merge'
import {cCssToJssImportant} from '@converdy/styles/c-css-to-jss'
import objectMap from '@converdy/utils/object-map'
import * as cComponentStyles from '@converdy/c-components/indexStyles'
import * as selectorsMap from '@converdy/c-components/indexSelectors.js'  

export function createComponentStyleSheet(jssInstance, jssObject, id) {
  
  const generateId = ({ key }, sheet) => {
    return id
  }
  return jssInstance.createStyleSheet(jssObject, { generateId, index: 2, meta: 'element-styles'})

}


export function componentJss(tagName, computedProperties) {

  const styleFunction = cComponentStyles[tagName]

  const styleFromStylingFunction = (styleFunction && styleFunction(computedProperties)) || {}

  const { styles = {} } = computedProperties

  const cComponentSelectors = selectorsMap[tagName] || []
  
  let styleFromAdvancedStyling = {}

  /*
   * iterate through top-level responsive styles keys
   * mobile, tablet & desktop
   */
  Object.entries(styles).forEach(
    ([ breakpoint, breakpointStyles ]) => {
      let computedBreakpointStyles = {}

      /*
       * iterate through all available element selectors of a c-component
       */
      cComponentSelectors.forEach(
        ({ selector: nodeSelector, name }) => {
          const selectors = breakpointStyles[name]

          if (selectors) {
            /*
             * iterate through all extended / pseudo-selectors for the current element
             * e.g. (:hover), (:active) or ( .custom-nested-selector)
             */
            Object.entries(selectors).forEach(
              ([ selector, style ]) => {
                const computedSelector = selector === 'default'
                  ? nodeSelector
                  : nodeSelector + selector

                computedBreakpointStyles = merge(
                  computedBreakpointStyles,
                  { root: { [ computedSelector ]: style } }
                )
              }
            )
          }
        }
      )

      const breakpointJss = objectMap(cCssToJssImportant)(computedBreakpointStyles)

      /*
       * maybe this should come from some place dynamically
       * like letting the user set this in the theme settings
       */
      const breakPointPixels = { tablet: 768, mobile: 576 }

      if (breakpoint !== 'desktop') {
        styleFromAdvancedStyling = merge(
          styleFromAdvancedStyling,
          { [ `@media screen and (max-width: ${breakPointPixels[breakpoint]}px)` ]: breakpointJss }
        )
      } else {
        styleFromAdvancedStyling = merge(
          styleFromAdvancedStyling,
          breakpointJss
        )
      }
    }
  )
  
  return merge(
    {},
    styleFromStylingFunction,
    styleFromAdvancedStyling
  )
}